import amplitude from 'amplitude-js';
import Config from '../config';
import {ITrackingEvent, ITrackingRevenue} from "../interfaces/tracking.interface";

// Start amplitude to track events
export const initTracking = () => {
	if (!amplitudeEnabled()) {
		console.error(
			`Can't initialize amplitude with no api key. Did you add it in the environments file?`
		);
		return;
	}
	amplitude.getInstance().init(Config.amplitudeApi, null, {
        apiEndpoint: 'api.eu.amplitude.com'
    });
};

// Set this the instant the user is identifiable
export const setUserIdentifier = (userIdentifier: string) => {
	if (!amplitudeEnabled()) {
		return;
	}
	amplitude.getInstance().setUserId(userIdentifier);
};

export const trackEvent = (trackingEvent: ITrackingEvent) => {
	if (!amplitudeEnabled()) {
		return;
	}

	validateEvent(trackingEvent);
	amplitude.getInstance().logEvent(trackingEvent.event, trackingEvent.properties);
}

// Special event, created specifically to track revenue.
export const trackRevenue = (revenue: ITrackingRevenue) => {
	if (!amplitudeEnabled()) {
		return;
	}

	const event = new amplitude.Revenue()
		.setProductId(revenue.productId)
		.setPrice(revenue.price)
		.setQuantity(revenue.quantity);
	amplitude.getInstance().logRevenueV2(event);
}


const validateEvent = (event: ITrackingEvent) => {
	const allWordsHaveCapitalFirstLetter: boolean = event.event
		.split(' ')
		.every((word: string) => word.match(/^[A-Z][a-z0-9_-]{1,19}$/));

	if (!allWordsHaveCapitalFirstLetter) {
		throw Error('Wrong event implementation. First letter in every word must be uppercase.');
	}
}

const amplitudeEnabled = () => {
	return Config.amplitudeApi?.length > 0
};
